module.exports = __webpack_public_path__ + "img/15.b6a653f0.jpeg";